/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { set_value_bi, edit_inside_object } from "../../App/actions/biActions";

/*PICTURE*/

/*FUNCTION*/
import { ErrorContext } from "../../Debug/ErrorHandler/ErrorContext";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

class BI_ADD_STEP_5_DEFAULT_VALUE extends Component {
  state = {};

  static contextType = ErrorContext;

  on_change_card_add_object = (e) => {
    const { handleError } = this.context;

    handleError(() => {
      const id_key = e.target.name;
      const value = e.target.value;
      this.props.edit_inside_object({
        key: "card_add_object",
        id_key: id_key,
        value: value,
      });
    })();
  };

  on_prev_step = () => {
    const { handleError } = this.context;

    handleError(() => {
      const { add_card_current_step } = this.props.bi;
      this.props.set_value_bi({
        key: "add_card_current_step",
        value: add_card_current_step - 1,
      });
    })();
  };

  on_next_step = () => {
    const { handleError } = this.context;

    handleError(() => {
      const { add_card_current_step } = this.props.bi;
      this.props.set_value_bi({
        key: "add_card_current_step",
        value: add_card_current_step + 1,
      });
    })();
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state

    //global props
    const { card_add_object } = this.props.bi;

    //content
    const { default_value } = card_add_object;

    return (
      <main>
        <h1 className="text_bold margin_bottom">
          {dict?.["Enter default value"]?.[language]}
        </h1>
        <p className="text_small">
          {dict?.["Default value if data has not been filled in"]?.[language]}
        </p>
        <p className="text_bold">
          {dict?.["If there is no default value, fill it with 0"]?.[language]}
        </p>
        <br />
        <input
          placeholder={
            dict?.["If there is no default value, fill it with 0"]?.[language]
          }
          type="text"
          name="default_value"
          value={default_value}
          onChange={this.on_change_card_add_object}
          data-mapid="inputValue"
        />
        <button
          onClick={this.on_prev_step}
          className="button margin_bottom margin_right inline background_black"
        >
          {dict?.["Previous step"]?.[language]}
        </button>
        <button
          onClick={this.on_next_step}
          data-mapid="clickNext"
          className="button background_black"
        >
          {dict?.["Next step"]?.[language]}
        </button>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  bi: state.bi,
});

export default connect(mapStateToProps, {
  set_value_bi,
  edit_inside_object,
})(BI_ADD_STEP_5_DEFAULT_VALUE);
